import { FC } from 'react';

import { Box } from '@mantine/core';

import { CompanyProfile } from 'models';

import { CompanyLogoFallback } from 'components/company-logo/CompanyLogoFallback';
import { IKImage } from 'components/ik-image/IKImage';

import cx from '../CompanyProfileTeaser.module.scss';

const Logo: FC<{
    company: CompanyProfile;
    withBorder?: boolean;
    size?: number;
    fullWidth?: boolean;
}> = ({ company, withBorder, size, fullWidth }) => {
    const companyLogo = company.logos.small || company.logos.large;

    return (
        <Box
            className={cx.logoWrapper}
            data-variant={withBorder ? 'bordered' : undefined}
            w={fullWidth ? '100%' : size}
            h={fullWidth ? 'auto' : size}
            style={fullWidth ? { aspectRatio: 1 } : undefined}
        >
            {companyLogo ? (
                <IKImage
                    fileOrId={companyLogo as any}
                    width={200}
                    alt={company.name}
                    loading="eager"
                    fetchPriority="high"
                />
            ) : (
                <CompanyLogoFallback
                    name={company.name}
                    color={company.color}
                    size={fullWidth || (size && size < 60) ? 'sm' : 'lg'}
                />
            )}
        </Box>
    );
};

export { Logo };
